import { ReactFlowProvider } from '@xyflow/react';
import { FC, memo } from 'react';

interface FlowWrapperProviderProps {
  children?: React.ReactNode;
}
const FlowWrapperProvider: FC<FlowWrapperProviderProps> = ({ children }) => {
  return <ReactFlowProvider>{children}</ReactFlowProvider>;
};

export default memo(FlowWrapperProvider);
